import { api, client } from '../feathers'

export const useFeathers = () => {
    return { api, client }
}